import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL, BRAND } from "@/lib/constants";

export default function Impressum() {
  return (
    <div className="bg-white min-h-screen" data-testid="impressum-page">
      <header className="border-b border-neutral-200">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="impressum-back-home">
            <img src={LOGO_URL} alt="Rosenberg Objektservice" className="h-14 w-auto object-contain" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm uppercase tracking-wider font-semibold text-[#0A0A0A] hover:text-[#8A151B] transition-colors"
          >
            <ArrowLeft size={16} />
            Zurück
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#8A151B]" />
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#8A151B]">
            Rechtliches
          </span>
        </div>

        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-[#0A0A0A]">
          Impressum
        </h1>

        <p className="mt-6 text-sm text-neutral-500 uppercase tracking-wider">
          Angaben gemäß § 5 DDG
        </p>

        <div className="mt-12 space-y-10">
          <section>
            <h2 className="font-display text-lg font-bold uppercase tracking-wider text-[#0A0A0A]">
              Anbieter
            </h2>
            <div className="mt-4 border-l-2 border-[#8A151B] pl-6 space-y-1 text-base text-neutral-700">
              <p className="font-semibold text-[#0A0A0A]">Marc Rosenberg</p>
              <p>Rosenberg Objektservice</p>
              <p>Weserstraße 3</p>
              <p>63322 Rödermark</p>
              <p>Deutschland</p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-lg font-bold uppercase tracking-wider text-[#0A0A0A]">
              Kontakt
            </h2>
            <div className="mt-4 border-l-2 border-[#8A151B] pl-6 space-y-1 text-base text-neutral-700">
              <p>
                Telefon:{" "}
                <a
                  href={`tel:${BRAND.phoneIntl}`}
                  className="text-[#8A151B] hover:underline"
                >
                  {BRAND.phone}
                </a>
              </p>
              <p>
                E-Mail:{" "}
                <a
                  href={`mailto:${BRAND.email}`}
                  className="text-[#8A151B] hover:underline"
                >
                  {BRAND.email}
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-lg font-bold uppercase tracking-wider text-[#0A0A0A]">
              Aufsichtsbehörde
            </h2>
            <div className="mt-4 border-l-2 border-[#8A151B] pl-6 space-y-1 text-base text-neutral-700">
              <p>Kreis Offenbach</p>
              <p>Werner-Hilpert-Straße 1</p>
              <p>63128 Dietzenbach</p>
              <p className="mt-2 text-sm text-neutral-600">
                Erlaubnis nach § 34c Gewerbeordnung (GewO), erteilt durch
                den Kreis Offenbach.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-lg font-bold uppercase tracking-wider text-[#0A0A0A]">
              Berufshaftpflichtversicherung
            </h2>
            <div className="mt-4 border-l-2 border-[#8A151B] pl-6 space-y-1 text-base text-neutral-700">
              <p className="font-semibold text-[#0A0A0A]">
                SV SparkassenVersicherung Gebäudeversicherung AG
              </p>
              <p>Löwentorstraße 65</p>
              <p>70376 Stuttgart</p>
              <p>Deutschland</p>
              <p className="mt-2 text-sm text-neutral-600">
                Geltungsbereich der Versicherung: Deutschland
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-lg font-bold uppercase tracking-wider text-[#0A0A0A]">
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <div className="mt-4 border-l-2 border-[#8A151B] pl-6 space-y-1 text-base text-neutral-700">
              <p>Marc Rosenberg</p>
              <p>Weserstraße 3</p>
              <p>63322 Rödermark</p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-lg font-bold uppercase tracking-wider text-[#0A0A0A]">
              Haftungsausschluss
            </h2>
            <div className="mt-4 space-y-4 text-base text-neutral-700 leading-relaxed">
              <p>
                <strong className="text-[#0A0A0A]">Haftung für Inhalte:</strong>{" "}
                Die Inhalte dieser Seite wurden mit größter Sorgfalt erstellt.
                Für die Richtigkeit, Vollständigkeit und Aktualität der
                Inhalte kann jedoch keine Gewähr übernommen werden. Als
                Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich.
              </p>
              <p>
                <strong className="text-[#0A0A0A]">Haftung für Links:</strong>{" "}
                Unser Angebot enthält ggf. Links zu externen Websites Dritter,
                auf deren Inhalte wir keinen Einfluss haben. Deshalb können
                wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige
                Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
              <p>
                <strong className="text-[#0A0A0A]">Urheberrecht:</strong> Die
                durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht.
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen
                der schriftlichen Zustimmung des jeweiligen Autors bzw.
                Erstellers.
              </p>
            </div>
          </section>

          <section className="pt-8 border-t border-neutral-200">
            <p className="text-sm text-neutral-500">
              Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-neutral-200 py-10">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs uppercase tracking-wider text-neutral-500">
          <p>© {new Date().getFullYear()} Rosenberg Objektservice</p>
          <div className="flex gap-6">
            <Link to="/" className="hover:text-[#8A151B] transition-colors">
              Startseite
            </Link>
            <Link to="/datenschutz" className="hover:text-[#8A151B] transition-colors" data-testid="impressum-footer-datenschutz">
              Datenschutz
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
